import { UIElement, UIElementTypes } from '../element';
import RectangleUiListElement from './ButtonUiListElement.svelte';
import '../../types';
import { createBangleJSUiCode } from './bangleCode';
import { isPointInRectangle } from '../../utils/helpers';
import { elementSelectionStore } from '../../stores/elementsSelection';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../constants';
export class UIButton extends UIElement {
    constructor(args) {
        super(UIElementTypes.BUTTON, args.x, args.y, args.z, args.name, args.id);
        this.width = args.width;
        this.height = args.height;
        this.backgroundColor = args.backgroundColor;
        this.textColor = args.textColor;
        this.text = args.text;
        this.fontSize = args.fontSize;
        this.hitBoxOffsetXLeft = args.hitBoxOffsetXLeft;
        this.hitBoxOffsetXRight = args.hitBoxOffsetXRight;
        this.hitBoxOffsetYTop = args.hitBoxOffsetYTop;
        this.hitBoxOffsetYBottom = args.hitBoxOffsetYBottom;
        this.showHitBox = args.showHitBox;
        this.vibrate = args.vibrate;
        this.group = args.group;
    }
    convertToCode() {
        return createBangleJSUiCode(this.x, this.y, this.z, this.getRenderBox(), this.name, this.width, this.height, this.backgroundColor, this.textColor, this.text, this.fontSize, {
            hitBoxOffsetXLeft: this.hitBoxOffsetXLeft,
            hitBoxOffsetXRight: this.hitBoxOffsetXRight,
            hitBoxOffsetYTop: this.hitBoxOffsetYTop,
            hitBoxOffsetYBottom: this.hitBoxOffsetYBottom,
        }, this.vibrate);
    }
    shouldScaleBeAdjusted(capturedEvent, eventValue) {
        return ['drag', 'rotate'].indexOf(eventValue.action) == -1 && capturedEvent !== 'moving';
    }
    convertToUiElement(mountPoint, uiElement, origin) {
        return new RectangleUiListElement({ target: mountPoint, props: { uiElement, origin } });
    }
    isSelected(pointerX, pointerY) {
        return isPointInRectangle(pointerX, pointerY, { x: this.x, y: this.y }, {
            x: this.x + this.width,
            y: this.y + this.height
        });
    }
    fitText(fontSize, ctx) {
        fontSize--;
        ctx.font = `${fontSize}px sans-serif`;
        const maxTextWidth = this.width - 10;
        let textWidth = ctx.measureText(this.text).width;
        let spacePerChar = textWidth / this.text.length;
        let maxCharsPerLine = Math.floor(maxTextWidth / spacePerChar);
        let numberOfFullLines = this.text.length / maxCharsPerLine;
        let textLines = [];
        if (textWidth > maxTextWidth) {
            maxCharsPerLine = Math.floor(maxTextWidth / spacePerChar);
            numberOfFullLines = Math.floor(this.text.length / maxCharsPerLine);
            for (let i = 0; i < numberOfFullLines; i++) {
                textLines.push(this.text.substring(i * maxCharsPerLine, i * maxCharsPerLine + maxCharsPerLine));
            }
            const lastLine = this.text.substring(numberOfFullLines * maxCharsPerLine);
            if (lastLine.length > 0) {
                textLines.push(lastLine);
            }
        }
        else {
            textLines = [this.text];
        }
        return { textLines, fontSize };
    }
    renderElement(ctx, originCoords) {
        const selected = elementSelectionStore.isSelected(this);
        const x = this.x + originCoords.x;
        const y = this.y + originCoords.y;
        const path = new Path2D();
        path.moveTo(x, y);
        path.lineTo(x + this.width, y);
        path.lineTo(x + this.width, y + this.height);
        path.lineTo(x, y + this.height);
        path.lineTo(x, y + this.height);
        path.closePath();
        if (selected) {
            ctx.fillStyle = 'green';
        }
        else {
            ctx.fillStyle = this.backgroundColor;
        }
        ctx.fill(path, 'evenodd');
        ctx.font = `${this.fontSize}px sans-serif`;
        let { textLines, fontSize } = this.fitText(this.fontSize, ctx);
        while (textLines.length * fontSize > this.height && fontSize > 8) {
            const fitResult = this.fitText(fontSize, ctx);
            textLines = fitResult.textLines;
            fontSize = fitResult.fontSize;
        }
        const longestLine = textLines.reduce((a, b) => a.length > b.length ? a : b);
        const longestLineWidth = ctx.measureText(longestLine).width;
        ctx.fillStyle = 'black';
        const textXPosition = x + this.width / 2 - longestLineWidth / 2;
        const textYPosition = y + this.height / 2 - (fontSize * (textLines.length === 1 ? 1 : textLines.length)) / 2.5;
        textLines.forEach((line, index) => {
            ctx.fillText(line, textXPosition, textYPosition + index * fontSize);
        });
        if (this.showHitBox) {
            const path = new Path2D();
            path.moveTo(x - this.hitBoxOffsetXLeft, y - this.hitBoxOffsetYTop);
            path.lineTo(x + this.width + this.hitBoxOffsetXRight, y - this.hitBoxOffsetYTop);
            path.lineTo(x + this.width + this.hitBoxOffsetXRight, y + this.height + this.hitBoxOffsetYBottom);
            path.lineTo(x - this.hitBoxOffsetXLeft, y + this.height + this.hitBoxOffsetYBottom);
            path.closePath();
            ctx.strokeStyle = 'blue';
            ctx.stroke(path, 'evenodd');
        }
    }
    moveElement(deltaX, deltaY) {
        this.x += deltaX;
        this.y += deltaY;
    }
    get isOutsideOfScreenArea() {
        return this.x + this.width <= 0 || this.x >= SCREEN_WIDTH || this.y + this.height <= 0 || this.y >= SCREEN_HEIGHT;
    }
    getRenderBox() {
        return {
            tl: { x: this.x, y: this.y },
            br: { x: this.x + this.width, y: this.y + this.height }
        };
    }
}
